import "./Insights.module.css";
import Header from "@/reusable_sections/Header";
import TechIntelligence from "./sections/TechIntelligence";
import SubscribeToTheFuture from "./sections/SubscribeToTheFuture";
import Footer from "@/reusable_sections/Footer";
export default function InsightsPage() {
  return <div>
      <Header />
      <TechIntelligence />
      <SubscribeToTheFuture />
      <Footer />
    </div>;
}